export default __webpack_public_path__ + "static/media/marijuana.d759407a.svg";